import { Badge, HStack, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

import { NodePrimitive } from "@/design-system/primitives";
import type { PrimitiveTone } from "@/design-system/tokens";

interface PrimitiveBadgeProps {
  readonly children: ReactNode;
  readonly tone?: PrimitiveTone;
}

export function PrimitiveBadge({ children, tone = "blue" }: PrimitiveBadgeProps) {
  return (
    <Badge
      position="relative"
      overflow="hidden"
      bg="linear-gradient(135deg, rgba(255,255,255,0.14), rgba(55,213,255,0.08), rgba(255,79,216,0.08))"
      color="white"
      border="1px solid"
      borderColor="whiteAlpha.400"
      borderRadius="999px"
      px={3}
      py={1}
      textTransform="uppercase"
      letterSpacing="0"
      boxShadow="0 0 18px rgba(55,213,255,0.16), inset 0 1px 0 rgba(255,255,255,0.16)"
    >
      <HStack gap={2}>
        <NodePrimitive
          tone={tone}
          position="relative"
          h="8px"
          w="8px"
          borderWidth="1px"
        />
        <Text as="span" fontSize="xs" fontWeight={900}>
          {children}
        </Text>
      </HStack>
    </Badge>
  );
}
